export function decodeParams(params) {
  const decodedParams = {};
  for (const key in params) {
    if (!params.hasOwnProperty(key)) continue;
    decodedParams[key] = decodeURIComponent(params[key]);
  }
  return decodedParams;
}


// WEBPACK FOOTER //
// ./src/utils/params.js